// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JlLOw","index":"styles_index__2FZD8"};